import { render } from "./NextPrev.vue?vue&type=template&id=66cdcd6e&scoped=true"
import script from "./NextPrev.vue?vue&type=script&lang=js"
export * from "./NextPrev.vue?vue&type=script&lang=js"

import "./NextPrev.vue?vue&type=style&index=0&id=66cdcd6e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cdcd6e"]])

export default __exports__